import { Purpose } from '@axo/shared/data-access/types';
import { z } from 'zod';
import { termsAndConditionsSchema } from '../../../../../components/ConsentSection/@types/Terms.types';
import { MarketingConsentFields } from '../../../../../hooks/useMarketingConsent';
import { PHONE_REGEX } from '../globals';

export const finlandStep1Schema = z
  .object({
    'Consent/terms': z.array(termsAndConditionsSchema).optional(),
    'Consent/originAction': z.string().optional(),
    'LoanApplication/AcceptTermsConditions': z.boolean().default(true),
    'LoanApplication/TermsAndConditionsText': z.string().optional(),
    'Ignore/MarketingConsent': z.boolean().default(false),

    'LoanApplication/AppliedAmount': z.coerce.number().min(500).max(70_000),
    'LoanApplication/LoanDuration': z.coerce.number().min(1).max(15),
    'Customer/Email': z
      .string({ required_error: 'Email.error.required' })
      .email('Email.error.pattern'),
    'Customer/MobilePhoneNumber': z.preprocess(
      (value) => String(value).replaceAll(' ', ''),
      z
        .string()
        .min(1, { message: 'MobilePhoneNumber.error.required' })
        .refine(
          (value) => PHONE_REGEX.test(value),
          'MobilePhoneNumber.error.pattern'
        )
    ),
    'LoanApplication/InitialPurpose': z
      .nativeEnum(Purpose)
      .default(Purpose.Other),
    'LoanApplication/Purpose': z.nativeEnum(Purpose).default(Purpose.Other),
  })
  .transform((data) => ({
    ...data,
    'LoanApplication/Purpose': data['LoanApplication/InitialPurpose'],
  }));

export type Step1Data = z.infer<typeof finlandStep1Schema> &
  MarketingConsentFields;

export default finlandStep1Schema;
